import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { MenuIcon, CancelIcon } from '@chegg-ui/theme';
import { sessionLogger } from '@chegg-ui/utils';
import { clickBaseEvent } from '@chegg-me-components/utils';
import { MenuButton, NavDropdown, NavDropdownCloseButton, DropdownUL, NavDropdownLI, NavDropdownLink, VisuallyHidden } from '../../styles';
import mainNavLinks, { getVisibleLinks } from '../mainNavLinks';
import useNavMenuBehavior from '../useNavMenuBehavior';
import { rioClient } from './../rio';

var DesktopHamburgerMenu = function DesktopHamburgerMenu(_ref) {
  var envUrl = _ref.envUrl,
      pageTrackId = _ref.pageTrackId,
      navType = _ref.navType,
      eligibility = _ref.eligibility;

  var _useNavMenuBehavior = useNavMenuBehavior(),
      navMenuRef = _useNavMenuBehavior.navMenuRef,
      navHamburgerButtonRef = _useNavMenuBehavior.navHamburgerButtonRef,
      navMenuOpen = _useNavMenuBehavior.navMenuOpen,
      setNavMenuOpen = _useNavMenuBehavior.setNavMenuOpen,
      onNavKeyDown = _useNavMenuBehavior.onNavKeyDown,
      onNavCloseButtonClick = _useNavMenuBehavior.onNavCloseButtonClick;

  var visibleLinks = getVisibleLinks(mainNavLinks[navType], eligibility);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuButton, {
    onClick: function onClick() {
      /**
       * Rio logging on opening the menu dropdown
       */
      rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
        data: {
          interaction: {
            type: 'expand',
            element: {
              name: 'nav hamburger',
              type: 'drop down',
              region_name: 'nav hamburger'
            }
          }
        }
      })); // button is hidden when the menu is open, so else case isn't possible

      /* istanbul ignore else */

      if (!navMenuOpen) {
        sessionLogger.event(envUrl, pageTrackId, {
          hamburger_open: true
        });
      }

      setNavMenuOpen(true);
    },
    screenReaderOnlyText: "secondary navigation",
    "data-test": "header-hamburger",
    isHidden: navMenuOpen,
    "aria-expanded": navMenuOpen,
    ref: navHamburgerButtonRef
  }, /*#__PURE__*/React.createElement(MenuIcon, null)), /*#__PURE__*/React.createElement(NavDropdown, {
    isOpen: navMenuOpen,
    ref: navMenuRef,
    role: "navigation",
    "aria-label": "secondary",
    onKeyDown: onNavKeyDown
  }, /*#__PURE__*/React.createElement(NavDropdownCloseButton, {
    onClick: onNavCloseButtonClick,
    screenReaderOnlyText: "close navigation",
    "data-test": "header-close-hamburger"
  }, /*#__PURE__*/React.createElement(CancelIcon, null)), /*#__PURE__*/React.createElement(DropdownUL, null, visibleLinks.map(function (linkDetails) {
    var IconComponent = linkDetails.icon;
    return /*#__PURE__*/React.createElement(NavDropdownLI, {
      key: linkDetails.text
    }, /*#__PURE__*/React.createElement(NavDropdownLink, {
      href: "".concat(envUrl).concat(linkDetails.href),
      isActive: navType === linkDetails.type,
      "data-test": "header-hamburger-".concat(linkDetails.loggingKey),
      onClick: function onClick() {
        /**
         * Rio logging for click on menu links in dropdown
         */
        rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
          data: {
            interaction: {
              type: 'select',
              element: {
                name: 'nav hamburger item',
                type: 'link',
                region_name: 'nav hamburger',
                value: linkDetails.text
              }
            }
          }
        }));
        /**
         * session logging
         */

        sessionLogger.event(envUrl, pageTrackId, {
          hamburger_click: linkDetails.loggingKey
        });
      }
    }, /*#__PURE__*/React.createElement(IconComponent, {
      size: "medium",
      role: "presentation"
    }), navType === linkDetails.type && /*#__PURE__*/React.createElement(VisuallyHidden, null, "Current Page: "), /*#__PURE__*/React.createElement("span", null, linkDetails.text)));
  }))));
};

DesktopHamburgerMenu.displayName = 'DesktopHamburgerMenu';
export default DesktopHamburgerMenu;